import "./PromoBubble.scss";

export interface PromoBubbleProps {
  /** 气泡文案。空串/空白会直接返回 null —— 消费方不需要在外面再判一次 */
  text?: string | null;
  /** 追加到根节点的 class，便于消费方做位置微调 */
  className?: string;
}

/**
 * 注册按钮上方的首充优惠气泡。金色渐变 + 朝下三角，定位 absolute；
 * 需要由消费方在父容器上 position: relative。
 */
export function PromoBubble({ text, className = "" }: PromoBubbleProps) {
  const trimmed = text?.trim();
  if (!trimmed) return null;
  return (
    <span
      className={`promo-bubble ${className}`.trim()}
      role="note"
      aria-hidden="true"
    >
      <span className="promo-bubble__text">{trimmed}</span>
    </span>
  );
}

export default PromoBubble;
